<template>
  <div
    v-if="!editorIsFullscreen"
    class="full-slide-overlay"
  >
    <div
      class="full-slide-overlay__headline-wrapper"
    >
      <h1 class="full-slide-overlay__headline">
        {{ headline }}
      </h1>
    </div>
    <MysteryPlayButton
      class="full-slide-overlay__mystery-play-button"
      tag-name="button"
      @click="showFullscreen"
    />
    <div
      class="full-slide-overlay__image-wrapper"
    >
      <img
        v-if="thumbnailUrl"
        :src="thumbnailUrl"
      >
    </div>
  </div>
</template>

<script>
import { MysteryPlayButton } from '@discoveryedu/mystery-components';
import { mapState, mapActions } from 'pinia';
import { bus } from '@/lib/eventBus';
import { getRefThumbnail } from '@/lib/utils';
import * as types from '@/lib/constants/store';
import {
  useEditorStore,
} from '@/stores';

export default {
  name: 'FullSlideOverlay',
  components: {
    MysteryPlayButton,
  },
  data() {
    return {
      thumbnailUrl: null,
    };
  },
  props: {
    page: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState(useEditorStore, [
      'draft',
      'editorIsFullscreen',
      'overlayThumbnail',
      'currentPageIndex',
    ]),
    headline() {
      return this.draft?.name;
    },
    themeName() {
      return this.page?.options?.theme?.name;
    },
    useMysteryPlayButton() {
      return this.themeName === 'mystery-science' && this.$route?.name !== 'print-preview';
    },
  },
  async mounted() {
    // check store for a cached overlay thumbnail
    if (this.overlayThumbnail) {
      this.thumbnailUrl = this.overlayThumbnail;
    } else {
      try {
        const thumbnail = await getRefThumbnail(this.draft, this.page);
        this.thumbnailUrl = thumbnail.url;

        // cache
        this[types.SET_OVERLAY_THUMBNAIL](this.thumbnailUrl);
      } catch (e) {
        // do nothing if we didn't get a thumbnail
      }
    }
    if (this.editorIsFullscreen) {
      bus.emit('firstplay');
    }
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.SET_OVERLAY_THUMBNAIL,
    ]),
    showFullscreen() {
      bus.emit('requestFullscreen');
    },
  },
};
</script>
<style lang="stylus">
.full-slide-overlay {
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 25;
  &__image-wrapper:after {
    content: '';
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.45) 30%, rgba(0, 0, 0, 0.15));
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  themed-play-button(size) {
    $size-half = size / 2;
    height: size;
    left: "calc(50% - %s)" % $size-half;
    position: absolute;
    top: "calc(50% - %s)" % $size-half;
    width: size;
    z-index: 5;
  }
  &__mystery-play-button {
    themed-play-button(94px);
  }
  &__headline-wrapper {
    align-items: center;
    display: flex;
    height: 100%;
    left: 5%;
    position: absolute;
    width: 35%;
    z-index: 3;
  }
  &__headline {
    color: $nebula-color-white;
    font-family: "Agrandir", sans-serif;
    font-size: 48px;
    font-weight: 800;
    line-height: 1.1em;
  }
  &__image-wrapper {
    height: 100%;
    width: 100%;
    img {
      height: 100%;
      object-fit: cover;
      object-position: center;
      width: 100%;
    }
  }
}
</style>
